// import { Avatar } from "./Avatar";
import React from "react";

import SocialMedia from "./SocialMedia";
export const AvatarCard = (props) => {
	return (
		<div className="AvatarCard">
			{/* <Avatar className="AvatarCardAvatar" /> */}
			<div className="AvatarCardDiv">
				<p>Mateusz Cisło</p>
				{props.language === "pl" ? (
					<div style={{ textAlign: "left" }}>
						<p>Język: Javascript</p>
						<p>Telefon: 518-765-184</p>
					</div>
				) : (
					<div style={{ textAlign: "left" }}>
						<p>Language: Javascript</p>
						<p>Phone: +48 518-765-184</p>
					</div>
				)}
				<SocialMedia />
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/AvatarCard.js